import {connect} from 'react-redux';

import {EpicPlayerComponent} from '../EpicPlayer';
import {mapMessageStateToProps} from '../../../../message/Message';
import WithFullScreen from '../../../../../hocs/with-fullscreen/WithFullScreen';
import {appActions} from '../../../../../redux/actions';
import {TrackingEventTypes} from '../../../../../constants/Tracking';

/**
 * HLS player component
 *
 * @class HlsPlayerComponent
 * @extends EpicPlayerComponent
 */
export class HlsPlayerComponent extends EpicPlayerComponent {
    constructor(props) {
        super(props);
        console.debug('constructor', 'constructed', props);
        this.state = {
            ...this.state,
            recipe: props.recipe
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.retrieveAndSetSource();
    }

    renderSources(sources) {
        return null;
    }

    /**
     * Once the media metadata is returned, set the source of the video element.
     * @returns {Promise<void>}
     */
    async retrieveAndSetSource() {
        await this.retrieveMediaData(this.state.recipe.mediaRefId);
        if (this.video && this.isMounted) {
            this.video.src = this.specificMediaData.manifest.url;
        }
    }
}

const mapDispatchToProps = {
    trackEvent: params =>
        appActions.trackEvent(
            TrackingEventTypes.Interaction,
            'LauncherVideoPlayer',
            params.eventAction,
            params.eventLabel,
            params.eventValue
        )
};

export default connect(
    mapMessageStateToProps,
    mapDispatchToProps,
    null,
    /**
     * This is required by Redux so we can access the ref within the connected component.
     * @see: https://react-redux.js.org/api/connect#forwardref-boolean
     */
    {forwardRef: true}
)(WithFullScreen(HlsPlayerComponent));
